import { render } from "./publish-data.vue?vue&type=template&id=834ce5c8&scoped=true"
import script from "./publish-data.vue?vue&type=script&lang=js"
export * from "./publish-data.vue?vue&type=script&lang=js"

import "./publish-data.vue?vue&type=style&index=0&id=834ce5c8&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-834ce5c8"]])

export default __exports__